

import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import axios from 'axios'
import { BlacklistedProvider} from "@/domains/global/models";

@Component
export default class BannedProviderList extends Vue {
  private show = false
  private jobId: string | null = null
  private providers: BlacklistedProvider[] = []
  private loading = false

  open(jobId: string) {
    this.show = true
    this.jobId = jobId
    this.loading = true
    this.getProviders()
  }

  close() {
    this.show = false
    this.jobId = null
    this.providers = []
  }

  async getProviders() {
    const res = await axios.get<BlacklistedProvider[]>(`jobs/${this.jobId}/blacklisted`)
    this.providers = res.data
    this.loading = false
  }

  async unban(provider: BlacklistedProvider) {
    await axios.post(`jobs/${this.jobId}/blacklisted/${provider.id}/restore`)
    this.providers = this.providers.filter(p => p.id !== provider.id)
  }
}
